import React from "react";

const LinkedinPosts = ({ data }) => {
  const postCount = data.posts.length;

  return (
    <section id="linkedin">
      <div className="gg-container bg-lightBlue pb-32">
        <div
          id="linkedin-wrapper"
          className="
            grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3
            gap-[24px] laptop:gap-[30px] desktop:gap-[33px]
          "
        >
          {/* FIRST ROW (If there are 6 posts, this is shown first) */}
          {data.posts.slice(3, 6).map((post, index) => (
            <iframe
              key={index}
              src={`https://www.linkedin.com/embed/feed/update/urn:li:activity:${post}`}
              className="h-[400px] w-[440px] aspect-video rounded-lg shadow-lg fadeInUp"
              allowFullScreen
              title={`LinkedIn post ${index + 1}`}
              scrolling={post.includes("compact=1") ? "no" : "yes"}
            ></iframe>
          ))}

          {/* TEXT BETWEEN ROWS */}
          <div
            className={`col-span-1 tablet:col-span-2 laptop:col-span-3 text-center pb-6 ${postCount === 3 ? "pt-24" : "pt-6"}`}
          >
            <p
              className="text-2xl font-semibold text-darkBlue"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>

          {/* SECOND ROW (If only 3 posts exist, this is the only row) */}
          {data.posts.slice(0, 3).map((post, index) => (
            <iframe
              key={index + 3}
              src={`https://www.linkedin.com/embed/feed/update/urn:li:activity:${post}`}
              className="h-[400px] w-[440px] aspect-video rounded-lg shadow-lg fadeInUp"
              allowFullScreen
              title={`LinkedIn post ${index + 4}`}
              scrolling={post.includes("compact=1") ? "no" : "yes"}
            ></iframe>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LinkedinPosts;
